var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var SchemaModel = /** @class */ (function () {
    function SchemaModel(schema) {
        this.properties = Object.values(schema);
    }
    SchemaModel.prototype.getKeys = function (predicate) {
        if (predicate === void 0) { predicate = function () { return true; }; }
        return this.properties.filter(predicate).map(function (prop) { return prop.key; });
    };
    SchemaModel.prototype.pick = function (obj, predicate) {
        return this.getKeys(predicate).reduce(function (acc, key) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[key] = obj[key], _a)));
        }, {});
    };
    return SchemaModel;
}());
export { SchemaModel };
//# sourceMappingURL=SchemaModel.js.map